module.exports = __webpack_public_path__ + "static/media/Lobb-Bg.bf6dd8b0.jpg";